import { Box, Divider, Text, Paper, Stack } from "@mantine/core";
import React from "react";

import { VSpace } from "../../../../../components";
import { ISJArapport } from "../../../../../mc-shared/reportSchemas/sjaSchema";
import { SJAOptionsTable } from "./SJAOptionsTable";

const SJAOptions: React.FC<{
  editData: ISJArapport;
  updateData: (key: string, value: any) => void;
}> = ({ editData, updateData }) => {
  return (
    <>
      {editData != null && (
        <Box w="100%" p="md">
          <Divider
            mb="sm"
            label={
              <Text fz="lg" fw={600}>
                Aktuelle punkter
              </Text>
            }
            labelPosition="left"
          />
          {Object.entries(editData.options)?.map(([key, option]) => {
            return (
              <>
                <Paper withBorder p="sm" radius="sm" key={key}>
                  <Stack gap="xs">
                    <SJAOptionsTable category={key} editData={option} updateData={updateData} />
                  </Stack>
                </Paper>
                <VSpace />
              </>
            );
          })}
        </Box>
      )}
    </>
  );
};

export default SJAOptions;
